let zh = require('zh_cn')

function pinyinCountry (data) {
  data = data.sort(function (a, b) {
    let aS = zh(a.cnName)[0].substr(0, 1).toUpperCase()
    let bS = zh(b.cnName)[0].substr(0, 1).toUpperCase()
    if (aS < bS) {
      return -1
    } else if (aS > bS) {
      return 1
    }
    return 0
  })
  let letter = []
  data.map(function (item, index) {
    let en = zh(item.cnName)[0].substr(0, 1).toUpperCase()
    item.label = item.cnName
    item.id = index
    item.value = item.alpha2Code
    item.name = item.cnName
    let an = letter.some(function (t) {
      return t.label === en
    })
    if (!an) {
      letter.push({
        label: en,
        value: en,
        children: []
      })
      letter.map(function (n) {
        if (n.label === en) {
          n.children.push(item)
        }
      })
    } else {
      letter.map(function (n) {
        if (n.label === en) {
          n.children.push(item)
        }
      })
    }
  })
  return letter
}

function pinyinPost (carriers) {
  carriers = carriers.sort(function (a, b) {
    let aS = zh(a.zhName)[0].substr(0, 1).toUpperCase()
    let bS = zh(b.zhName)[0].substr(0, 1).toUpperCase()
    if (aS < bS) {
      return -1
    } else if (aS > bS) {
      return 1
    }
    return 0
  })
  let letter = []
  carriers.map(function (item, index) {
    let en = zh(item.zhName)[0].substr(0, 1).toUpperCase()
    item.id = index
    let an = letter.some(function (t) {
      return t.label === en
    })
    if (!an) {
      letter.push({
        label: en,
        children: []
      })
      letter.map(function (n) {
        if (n.label === en) {
          n.children.push(item)
        }
      })
    } else {
      letter.map(function (n) {
        if (n.label === en) {
          n.children.push(item)
        }
      })
    }
  })
  return letter
}

function pinyinCarriers (carriers) {
  carriers = carriers.sort(function (a, b) {
    let aS = zh(a.zhName)[0].substr(0, 1).toUpperCase()
    let bS = zh(b.zhName)[0].substr(0, 1).toUpperCase()
    if (aS < bS) {
      return -1
    } else if (aS > bS) {
      return 1
    }
    return 0
  })
  let letter = []
  carriers.map(function (item, index) {
    let en = zh(item.zhName)[0].substr(0, 1).toUpperCase()
    item.id = index
    item.label = item.zhName
    item.value = item.code
    let an = letter.some(function (t) {
      return t.label === en
    })
    if (!an) {
      letter.push({
        label: en,
        value: en,
        children: []
      })
      letter.map(function (n) {
        if (n.label === en) {
          n.children.push(item)
        }
      })
    } else {
      letter.map(function (n) {
        if (n.label === en) {
          n.children.push(item)
        }
      })
    }
  })
  return letter
}

function pinyinTags (carriers1) {
  let carriers = []
  carriers1.forEach((item,index) => {
    carriers.push({tagName:item,tagNameIndex:index})
  })
  carriers = carriers.sort(function (a, b) {
    let aS = zh(a.tagName)[0].substr(0, 1).toUpperCase()
    let bS = zh(b.tagName)[0].substr(0, 1).toUpperCase()
    if (aS < bS) {
      return -1
    } else if (aS > bS) {
      return 1
    }
    return 0
  })
  let letter = []
  carriers.map(function (item, index) {
    let en = zh(item.tagName)[0].substr(0, 1).toUpperCase()
    item.id = index
    item.label = item.tagName
    item.value = item.tagName
    let an = letter.some(function (t) {
      return t.label === en
    })
    if (!an) {
      letter.push({
        label: en,
        value: en,
        children: []
      })
      letter.map(function (n) {
        if (n.label === en) {
          n.children.push(item)
        }
      })
    } else {
      letter.map(function (n) {
        if (n.label === en) {
          n.children.push(item)
        }
      })
    }
  })
  return letter
}

function pinyinPlatform (data) {
  let letter = []
  data.map(function (item, index) {
    item.label = item.platform.name
    item.value = item.platform.code
    item.children = item.shopSummary.shops
    item.children.map(function (t, i) {
      t.label = t.shop.name
      t.value = {
        id: t.shop.id ? t.shop.id : '',
        name: t.shop.name
      }
    })
  })
  letter = data
  return letter
}

export {
  pinyinCountry,
  pinyinPost,
  pinyinCarriers,
  pinyinPlatform,
  pinyinTags
}



// WEBPACK FOOTER //
// ./src/public/pinyin.js